/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanBarcodeClassicIcon64Regular = forwardRef('ScanBarcodeClassicIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M11 13.5a1.5 1.5 0 0 0-3 0v37a1.5 1.5 0 0 0 3 0v-37Z" }),
        React.createElement("path", { d: "M18.5 12a1.5 1.5 0 0 1 1.5 1.5v31a1.5 1.5 0 1 1-3 0v-31a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M29.002 13.5a1.5 1.5 0 1 0-3 0v31a1.5 1.5 0 0 0 3 0v-31Z" }),
        React.createElement("path", { d: "M36.502 12a1.5 1.5 0 0 1 1.5 1.5v37a1.5 1.5 0 0 1-3 0v-37a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M47.002 13.5a1.5 1.5 0 1 0-3 0v31a1.5 1.5 0 0 0 3 0v-31Z" }),
        React.createElement("path", { d: "M56.003 13.5a1.5 1.5 0 0 0-3 0v37a1.5 1.5 0 1 0 3 0v-37Z" })));
});
